import { merge } from "lodash";
import { useRef } from "react";
import { BaseOptionChart } from "src/components/chart";
import useLocales from "src/hooks/useLocales";

export default function useOptionsChart() {
	const { translate } = useLocales();

	const lastCalculatedValueRef = useRef({});

	const options = merge(BaseOptionChart(), {
		chart: {
			animations: {
				enabled: true
			}
		},
		labels: [translate("overview.success"), translate("overview.error")],
		colors: ["#36B37E", "#FF5630"],
		legend: { show: false },
		dataLabels: { enabled: true, dropShadow: { enabled: false } },
		tooltip: {
			fillSeriesColor: false
		},
		plotOptions: {
			pie: {
				donut: {
					size: "60%",
					background: "transparent",
					labels: {
						show: true,
						name: {
							show: true
						},
						value: {
							show: true
						},
						total: {
							show: true,
							label: "Total"
						}
					}
				}
			}
		}
	});

	lastCalculatedValueRef.current = options;

	return {
		options
	};
}
